import thor from '@sl/thor';

export default thor;
